import { Injectable } from '@angular/core';

@Injectable()

export class ROUTES {
  get Menuitem(): RouteInfo[] {
    let USER: RouteInfo[] = [];
    let SubLead: RouteInfo[] = [];
    let SubReport: RouteInfo[] = [];
    let SubDashboard: RouteInfo[] = [];
    let SubCalendar: RouteInfo[] = [];
    let dashreport = parseInt(sessionStorage.getItem("isreport"));
    let camp = JSON.parse(sessionStorage.getItem("allcampaign"));
    /*  for(let i=0; i < camp.length; i++)
     {
       if(camp[i].id == 1)
         SubDashboard.push(inurance_sisense);
       if(camp[i].id == 2)
         SubDashboard.push(recruiting_sisense);
     } */

     SubCalendar.push(calendar)
     SubCalendar.push(calendarsetting)
    for (let i = 0; i < camp.length; i++) {
      if (camp[i].id == 1) {
        SubLead.push(insuleads);
        SubReport.push(insureport);
        SubDashboard.push(inurance_sisense);
      }
      if (camp[i].id == 2) {
        SubLead.push(careerlead);
        SubReport.push(careerreport);
        SubDashboard.push(recruiting_sisense);
      }
      if (camp[i].id == 3) {
        SubLead.push(autolead);
        SubReport.push(autoreport);
      }

      if (camp[i].id == 4) {
        SubLead.push(mortgagelead);
        SubReport.push(mortgagereport);
      }
    }
    if (sessionStorage.getItem('type') == '1')
      return Admin;
    if (sessionStorage.getItem('type') == '2') {
      //USER.push(sisensedashboards);
      if (dashreport == 1)
        USER.push({
          path: '', title: 'Dashboard', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: SubDashboard,
          exPath: '/login/ndsisense'
        });
      else
        USER.push(dashboards);
      USER.push(userslist);
      USER.push(addcampaign);
      USER.push(admindialer);
      USER.push(adminpackage);
      USER.push(admintopup);
      USER.push(autodial);
      // USER.push(compsetting);
      USER.push(setting);
      USER.push(signuptemplate);
      USER.push(livereport);
      return USER;
    }
    //return company;
    if (sessionStorage.getItem('type') == '3') {
      if (dashreport == 1)
        USER.push({
          path: '', title: 'Dashboard', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: SubDashboard,
          exPath: '/login/ndsisense'
        });
      else
        USER.push(dashboards);
      USER.push(userslist);
      USER.push(setting);
      USER.push(register);
      USER.push(livereport);
      return USER;
    }
    //return manager;
    if (sessionStorage.getItem('type') == '4') {
      /* let camp = JSON.parse(sessionStorage.getItem("allcampaign"));
      for(let i=0; i < camp.length; i++)
      {
        if(camp[i].id == 1)
        {
          SubLead.push(insuleads);
          SubReport.push(insureport);
        }
        if(camp[i].id == 2)
        {
          SubLead.push(careerlead);
          SubReport.push(careerreport);
        }
        if(camp[i].id == 3)
        {
          SubLead.push(autolead);
          SubReport.push(autoreport);
        }

        if(camp[i].id == 4)
        {
          SubLead.push(mortgagelead);
          SubReport.push(mortgagereport);
        }
      } */
      //USER.push(dashboards);if(dashreport==1)
      if (dashreport == 1)
        USER.push({
          path: '', title: 'Dashboard', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: SubDashboard,
          exPath: '/login/ndsisense'
        });
      else
        USER.push(dashboards);

      USER.push(campaign);
      USER.push(userslist);
      USER.push(callerid);
      // USER.push({
      //   path: '#', title: 'Leads', icon: 'mdi mdi-account-switch', class: 'has-arrow', label: '', labelClass: '', extralink: false,
      //   submenu: SubLead
      // });
      USER.push(leads)
      USER.push(ivr)
      USER.push(automation);


       USER.push(calendar);
       USER.push(kyc);
       /* USER.push({
        path: '#', title: 'Calendar', icon: 'mdi mdi-calendar', class: 'has-arrow', label: '', labelClass: '', extralink: false,
        submenu: SubCalendar
      }); */
      USER.push(setting);
      /* for(let i=0; i < camp.length; i++)
      {
        if(camp[i].id == 1)
        {
          USER.push(ins_report);
        }
       if(camp[i].id == 2)
        {
          USER.push(rcr_report);
        }
      }     */

      USER.push({path: '/report/report', title: 'Report', icon: 'mdi mdi-chart-line', class: '', label: '', labelClass: '', extralink: false,
  submenu: []})
      // USER.push(reports)

      return USER;
    }

    if (sessionStorage.getItem('type') == '5') {
      /* let camp = JSON.parse(sessionStorage.getItem("allcampaign"));
      for(let i=0; i < camp.length; i++)
      {
        if(camp[i].id == 1)
        {
          SubLead.push(insuleads);
          SubReport.push(insureport);
        }
        if(camp[i].id == 2)
        {
          SubLead.push(careerlead);
          SubReport.push(careerreport);
        }
        if(camp[i].id == 3)
        {
          SubLead.push(autolead);
          SubReport.push(autoreport);
        }

        if(camp[i].id == 4)
        {
          SubLead.push(mortgagelead);
          SubReport.push(mortgagereport);
        }
      } */
      //USER.push(dashboards);
      if (dashreport == 1)
        USER.push({
          path: '', title: 'Dashboard', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: SubDashboard,
          exPath: '/login/ndsisense'
        });
      else
        USER.push(dashboards);
        USER.push(campaign);
        USER.push(callerid);
      // USER.push({
      //   path: '#', title: 'Leads', icon: 'mdi mdi-account-switch', class: 'has-arrow', label: '', labelClass: '', extralink: false,
      //   submenu: SubLead
      // });
      USER.push(leads);
      USER.push(automation);
      USER.push(calendar);
      USER.push(setting);



      /*  for(let i=0; i < camp.length; i++)
       {
         if(camp[i].id == 1)
         {
           USER.push(ins_report);
         }
       if(camp[i].id == 2)
         {
           USER.push(rcr_report);
         }
       }     */
       USER.push({path: '/report', title: 'Report', icon: 'mdi mdi-chart-line', class: '', label: '', labelClass: '', extralink: false,
      submenu: []});
      // USER.push(reports)

      return USER;
    }

    /* if(sessionStorage.getItem('type')=='4')
    {
      let camp = JSON.parse(sessionStorage.getItem("allcampaign"));
      for(let i=0; i < camp.length; i++)
      {
        if(camp[i].id == 1)
        {
          SubLead.push(insuleads);
          SubReport.push(insureport);
        }
        if(camp[i].id == 2)
        {
          SubLead.push(careerlead);
          SubReport.push(careerreport);
        }
        if(camp[i].id == 3)
        {
          SubLead.push(autolead);
          SubReport.push(autoreport);
        }

        if(camp[i].id == 4)
        {
          SubLead.push(mortgagelead);
          SubReport.push(mortgagereport);
        }
      }
      USER.push(dashboards);
      USER.push(campaign);
      USER.push(userslist);
      USER.push(callerid);
      USER.push({
        path: '#', title: 'Leads', icon: 'mdi mdi-account-switch', class: 'has-arrow', label: '', labelClass: '', extralink: false,
        submenu: SubLead
      });
      USER.push(calendar);
      USER.push(setting);
      for(let i=0; i < camp.length; i++)
      {
        if(camp[i].id == 1)
        {
          USER.push(ins_report);
        }
        if(camp[i].id == 2)
        {
          USER.push(rcr_report);
        }
      }
     //USER.push({path: '#', title: 'Report', icon: 'mdi mdi-chart-line', class: 'has-arrow', label: '', labelClass: '', extralink: false,
     // submenu: SubReport});

      return USER;
    }

    if(sessionStorage.getItem('type')=='5')
    {
      let camp = JSON.parse(sessionStorage.getItem("allcampaign"));
      for(let i=0; i < camp.length; i++)
      {
        if(camp[i].id == 1)
        {
          SubLead.push(insuleads);
          SubReport.push(insureport);
        }
        if(camp[i].id == 2)
        {
          SubLead.push(careerlead);
          SubReport.push(careerreport);
        }
        if(camp[i].id == 3)
        {
          SubLead.push(autolead);
          SubReport.push(autoreport);
        }

        if(camp[i].id == 4)
        {
          SubLead.push(mortgagelead);
          SubReport.push(mortgagereport);
        }
      }
      USER.push(dashboards);
      USER.push(campaign);
      USER.push(callerid);
      USER.push({
        path: '#', title: 'Leads', icon: 'mdi mdi-account-switch', class: 'has-arrow', label: '', labelClass: '', extralink: false,
        submenu: SubLead
      });
      USER.push(calendar);
      USER.push(setting);
     for(let i=0; i < camp.length; i++)
      {
        if(camp[i].id == 1)
        {
          USER.push(ins_report);
        }
        if(camp[i].id == 2)
        {
          USER.push(rcr_report);
        }
      }
     //USER.push({path: '#', title: 'Report', icon: 'mdi mdi-chart-line', class: 'has-arrow', label: '', labelClass: '', extralink: false,
      //submenu: SubReport});

      return USER;
    } */

  }
}


import { RouteInfo } from './shared/sidebar/sidebar.metadata';

export const rcr_report = {
  path: '',
  title: 'Recruiting Report',
  icon: 'mdi mdi-chart-line',
  class: 'has-arrow',
  label: '',
  labelClass: '',
  extralink: false,
  submenu: [
    {
      path: '',
      title: 'Summary',
      icon: '',
      class: 'has-arrow',
      label: '',
      labelClass: '',
      extralink: false,
      submenu: [
        {
          path: 'careerreport/report/1',
          title: 'Attempt Summary',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'careerreport/report/2',
          title: 'Minutes Summary',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'careerreport/report/3',
          title: 'SMS Usage',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'careerreport/report/4',
          title: 'VoiceDrop Usage',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'careerreport/report/5',
          title: 'Email Usage',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'careerreport/report/6',
          title: 'Objection Summary',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'careerreport/report/7',
          title: 'Disposition Report',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        }

      ]
    },
    {
      path: '',
      title: 'Detailed',
      icon: '',
      class: 'has-arrow',
      label: '',
      labelClass: '',
      extralink: false,
      submenu: [
        {
          path: 'careerreport/detail/1',
          title: 'Call Report',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'careerreport/detail/2',
          title: 'Voice Mail',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'careerreport/detail/3',
          title: 'SMS Report',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'careerreport/detail/4',
          title: 'Email Report',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'careerreport/detail/5',
          title: 'Appointment Report',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'careerreport/detail/6',
          title: 'Callback Report',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
      ]
    }
  ]
};

export const ins_report = {
  path: '',
  title: 'Insurance Report',
  icon: 'mdi mdi-chart-line',
  class: 'has-arrow',
  label: '',
  labelClass: '',
  extralink: false,
  submenu: [
    {
      path: '',
      title: 'Summary',
      icon: '',
      class: 'has-arrow',
      label: '',
      labelClass: '',
      extralink: false,
      submenu: [
        {
          path: 'report/report/1',
          title: 'Attempt Summary',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'report/report/2',
          title: 'Minutes Summary',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'report/report/3',
          title: 'SMS Usage',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'report/report/4',
          title: 'VoiceDrop Usage',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'report/report/5',
          title: 'Email Usage',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'report/report/6',
          title: 'Objection Summary',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'report/report/7',
          title: 'Disposition Report',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        }

      ]
    },
    {
      path: '',
      title: 'Detailed',
      icon: '',
      class: 'has-arrow',
      label: '',
      labelClass: '',
      extralink: false,
      submenu: [
        {
          path: 'report/detail/1',
          title: 'Call Report',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'report/detail/2',
          title: 'Voice Mail',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'report/detail/3',
          title: 'SMS Report',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'report/detail/4',
          title: 'Email Report',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'report/detail/5',
          title: 'Appointment Report',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
        {
          path: 'report/detail/6',
          title: 'Callback Report',
          icon: '',
          class: '',
          label: '',
          labelClass: '',
          extralink: false,
          submenu: []
        },
      ]
    }
  ]
};

export const inurance_sisense: RouteInfo =
{
  path: '/dashboards/dashboard3/5fe08358d2a933002d44750f', title: 'Insurance Dashboard', icon: 'mdi mdi-chart-bar', class: '', label: '', labelClass: '', extralink: false, submenu: []
};
export const recruiting_sisense: RouteInfo =
{
  path: '/dashboards/dashboard3/5f75c5bfd0f21c002d2d47c1', title: 'Recruiting Dashboard', icon: 'mdi mdi-chart-bar', class: '', label: '', labelClass: '', extralink: false, submenu: []
};
export const sisensedashboards: RouteInfo =
{
  path: '', title: 'Dashboard', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: [],
  exPath: '/login/ndsisense'
};

export const dashboards: RouteInfo =
{
  path: '/dashboards/dashboard6', title: 'Dashboard', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: []
};




/* export const campaign: RouteInfo =
{
  path: '/dialer/campaign', title: 'Dialer', icon: 'mdi mdi-cellphone', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
}; */
export const campaign: RouteInfo =
{
  path: '/crm', title: 'CRM', icon: 'mdi mdi-cellphone', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const ivr: RouteInfo =
{
  path: '/ivrsetting', title: 'IVR', icon: 'mdi mdi-gender-transgender', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const userslist: RouteInfo =
{
  path: '/userslist', title: 'Agents', icon: 'mdi mdi-account-multiple-plus', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const callerid: RouteInfo =
{
  path: '/callerid', title: 'Caller Id', icon: 'mdi mdi-phone-in-talk', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const mainleads: RouteInfo =
{
  path: '#', title: 'Leads', icon: 'mdi mdi-account-switch', class: 'has-arrow', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const insuleads: RouteInfo =
{
  path: '/lead', title: 'Insurance Leads ', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: []
};

export const careerlead: RouteInfo =
{
  path: '/careerlead', title: 'Recruiting Leads', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: []
};

export const autolead: RouteInfo =
{
  path: '/autolead', title: 'Auto Dealership Leads', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: []
};

export const calendar: RouteInfo =
{
  path: '/calendar', title: 'Calendar', icon: 'mdi mdi-calendar', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const kyc: RouteInfo =
{
  path: '/kyc/kyc-list', title: 'KYC', icon: 'mdi mdi-account-check', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const calendarsetting: RouteInfo =
{
  path: '/calendarsetting', title: 'Calendar Setting', icon: 'mdi mdi-calendar', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const setting: RouteInfo =
{
  path: '/setting', title: 'Settings', icon: 'mdi mdi-settings', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const compsetting: RouteInfo =
{
  path: '#', title: 'Settings', icon: 'mdi mdi-settings', class: '', label: '', labelClass: '', extralink: false,
  submenu: [
    {
      path: '/setting', title: 'Settings', icon: 'mdi mdi-settings', class: '', label: '', labelClass: '', extralink: false,
      submenu: []
    },

    {
      path: '/dashboardsetting', title: 'Dashboard Settings', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false,
      submenu: []
    }
  ]
};

export const mainreport: RouteInfo =
{
  path: '#', title: 'Report', icon: 'mdi mdi-chart-line', class: 'has-arrow', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const insureport: RouteInfo =
{
  path: '/report', title: 'Insurance Report ', icon: 'mdi mdi-chart-line', class: '', label: '', labelClass: '', extralink: false, submenu: []
};

export const careerreport: RouteInfo =
{
  path: '/careerreport', title: 'Recruiting Report', icon: 'mdi mdi-chart-line', class: '', label: '', labelClass: '', extralink: false, submenu: []
};

export const autoreport: RouteInfo =
{
  path: '/autoreport', title: 'Auto dealership Report', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: []
};

export const mortgagereport: RouteInfo =
{
  path: '/mortgagereport', title: 'Mortgage Report', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: []
};

export const mortgagelead: RouteInfo =
{
  path: '/mortgagelead', title: 'Mortgage Leads', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: []
};

export const admindialer: RouteInfo =
{
  path: '/mangcampaign', title: 'Dialer Setting', icon: 'mdi mdi-settings-box', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const adminpackage: RouteInfo =
{
  path: '/package', title: 'Packages', icon: 'mdi mdi-package-variant', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const admintopup: RouteInfo =
{
  path: '/topuppackage', title: 'Topup Package', icon: 'mdi mdi-package', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const autodial: RouteInfo =
{
  path: '/autodialblok', title: 'Block Autodial', icon: 'mdi mdi-block-helper', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const signuptemplate: RouteInfo =
{
  path: '/signupemail', title: 'SignUpEmails', icon: 'mdi mdi-email', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const addcampaign: RouteInfo =
{
  path: '/addcampaign', title: 'Dialer', icon: 'mdi mdi-disqus', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const livereport: RouteInfo =
{
  path: '/livereport', title: 'Live Report', icon: 'mdi mdi-chart-bar', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const register: RouteInfo =
{
  path: '/registration', title: 'Registration', icon: 'mdi mdi-account-check', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

/* Admin Menu Start */
export const Admin: RouteInfo[] = [
  {
    path: '/dashboards/dashboard1', title: 'Dashboard', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },

  {
    path: '/dashboards/dashboard6', title: 'Dashboard', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
    path: '/userslist', title: 'Users', icon: 'mdi mdi-view-list', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/mangcampaign', title: 'Dialer', icon: 'mdi mdi-account-multiple-plus', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },

  {
    path: '/setting', title: 'Setting', icon: 'mdi mdi-settings', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/report', title: 'Report', icon: 'mdi mdi-chart-line', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  }


];
/* Admin Menu Stop */

/* Company Menu Start */
export const company: RouteInfo[] = [

  {
    path: '/dashboards/dashboard1', title: 'Dashboard', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
    path: '/dashboards/dashboard6', title: 'Dashboard', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
    path: '/userslist', title: 'Users', icon: 'mdi mdi-view-list', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/mangcampaign', title: 'Dialer Setting', icon: 'mdi mdi-settings-box', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/package', title: 'Packages', icon: 'mdi mdi-package-variant', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/topuppackage', title: 'Topup Package', icon: 'mdi mdi-package', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/autodialblok', title: 'Block Autodial', icon: 'mdi mdi-block-helper', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/setting', title: 'Setting', icon: 'mdi mdi-settings', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/signupemail', title: 'SignUpEmails', icon: 'mdi mdi-email', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/report', title: 'Report', icon: 'mdi mdi-chart-line', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/livereport', title: 'Live Report', icon: 'mdi mdi-chart-bar', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/addcampaign', title: 'Add Campaign', icon: 'mdi mdi-chart-bar', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  }


];
/* Company Menu Stop */

/* Manager Menu Start */
export const manager: RouteInfo[] = [

  {
    path: '/dashboards/dashboard1', title: 'Dashboard', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
    path: '/dashboards/dashboard6', title: 'Dashboard', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
    path: '/userslist', title: 'Users', icon: 'mdi mdi-view-list', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/setting', title: 'Setting', icon: 'mdi mdi-settings', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/registration', title: 'Registration', icon: 'mdi mdi-account-check', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/report', title: 'Report', icon: 'mdi mdi-chart-line', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  },
  {
    path: '/livereport', title: 'Live Report', icon: 'mdi mdi-chart-bar', class: '', label: '', labelClass: '', extralink: false,
    submenu: []
  }

];

/**@custom */
export const leads: RouteInfo =
{
  path: '/lead', title: 'Leads', icon: 'mdi mdi-account-switch', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

export const reports: RouteInfo =
{
  path: '#', title: 'Report', icon: 'mdi mdi-chart-line', class: '', label: '', labelClass: '', extralink: false,
  submenu: [
    {
      path: '/summaryreport', title: 'Summary Report', icon: 'mdi mdi-chart-line', class: '', label: '', labelClass: '', extralink: false, submenu: []
    },
    {
      path: '/detailreport', title: 'Detail Report', icon: 'mdi mdi-chart-line', class: '', label: '', labelClass: '', extralink: false, submenu: []
    },
  ]
}

export const automation: RouteInfo =
{
  path: '/automation', title: 'Automation', icon: 'mdi mdi-account-switch', class: '', label: '', labelClass: '', extralink: false,
  submenu: []
};

